export enum IconTypeEnum {
    Mountains = 'mountains-icon',
    Sea = 'seaside-icon',
    CityBreak = 'city-break-icon',
    CrossCountry = 'cross-country-icon',
}
